import { CardTheme, FixedCard } from '../../molecules/card/Card';

export function Osasc2Card() {
    return (
        <FixedCard
            body="De gegevens van het onderzoek zijn succesvol ontvangen. De somnoloog neemt contact met je op om de uitslag van het onderzoek met je te bespreken."
            cardTitle="Onderzoek afgerond"
            theme={CardTheme.white}
        />
    );
}
